/**
 * Add extra attributes to an order based on URL parameters
 *
 * gn => Groepsnaam / groupname, for example: Vissenkom
 * sn => Schoolnummer / Schoolnumber, for example S-07547
 * kc => Kindcode / Child code = ADE3F
 * utm_medium => The medium where the customer came from
 * utm_source => Source where client came from
 * utm_campaign => The current campaign
 */

import Cookies from 'js-cookie'

Date.prototype.addHours = function(h){
  this.setHours(this.getHours()+h);
  return this;
}

Date.prototype.addMinutes = function(h){
  this.setMinutes(this.getMinutes()+h);
  return this;
}

class OrderAttributes {
  constructor() {

    // Variables
    this.expiresInHours = window.expiresInHours ? window.expiresInHours : 24;
    this.expiresInMinutes = 0;

    // Init
    this.clearCampaignCookies();
    this.getOrderAttributes();
    this.saveOrderAttributes();
  }

  // Clear campaign cookies when a customer has completed checkout and placed a order
  // Works together with the clear-campaign-cookies key in the local storage of the campaign cookies extension
  clearCampaignCookies() {
    // Get local checkout extension storage
    let extensionStorage = parseJson(window.localStorage.getItem('extensionStorage'));

    // Check if the local storage includes the clear-campaign-cookies key in the name
    const clearCampaignCookies = extensionStorage && Object.keys(extensionStorage).find(key => key.includes('clear-campaign-cookies'));

    // Return if the clearCampaignCookies key is not found
    if (!clearCampaignCookies) {
      return;
    }

    // Clear all campaign cookies
    Cookies.remove('gn');
    Cookies.remove('sn');
    Cookies.remove('kc');
    Cookies.remove('utm_medium');
    Cookies.remove('utm_source');
    Cookies.remove('utm_campaign');

    // Remove the clearCampaignCookies key from the extension storage
    delete extensionStorage[clearCampaignCookies]

    // Set the new extension storage
    window.localStorage.setItem('extensionStorage', JSON.stringify(extensionStorage));
  }

  // Keys that can be passed through the URL and stored on the order.
  static get keys() {
    return ['gn', 'sn', 'kc', 'utm_medium', 'utm_source', 'utm_campaign'];
  }

  // Get order attributes from url, store in cookies and push them straight to
  // the live cart so they are carried into the order from any checkout entry
  // point (cart page or cart drawer), not only when /cart is visited.
  getOrderAttributes() {
    if (!window.location.search) {
      return false;
    }

    const params = new URLSearchParams(window.location.search);
    const keys = OrderAttributes.keys;

    if (!keys.some((key) => params.get(key))) {
      return false;
    }

    const expires = new Date().addHours(this.expiresInHours).addMinutes(this.expiresInMinutes);
    const attributes = {};

    keys.forEach((key) => {
      const value = params.get(key);
      if (value) {
        Cookies.set(key, value, { expires: expires });
        attributes[key] = value;
      } else {
        Cookies.remove(key);
      }
    });

    this.pushAttributes(attributes);
  }

  // Persist attributes on the live cart. Cart attributes stick to the cart
  // (even when empty) and are carried through to the order on checkout.
  async pushAttributes(attributes) {
    if (!attributes || Object.keys(attributes).length === 0) {
      return false;
    }

    const body = JSON.stringify({ attributes });

    try {
      return await fetch(window.Shopify.routes.root + 'cart/update.js', { ...fetchConfig(), ...{ body } });
    } catch (error) {
      console.error(error);
    }
  }

  // Mirror the stored cookies into the hidden inputs of every cart form (cart
  // page and cart drawer) so the form submit carries the attributes, and
  // re-sync them onto the cart.
  async saveOrderAttributes() {
    const attributes = {};

    OrderAttributes.keys.forEach((key) => {
      const value = Cookies.get(key);
      if (value === '' || value === undefined) {
        return;
      }

      document.querySelectorAll(`[name="attributes[${key}]"]`).forEach((input) => {
        input.value = value;
      });

      attributes[key] = value;
    });

    return this.pushAttributes(attributes);
  }

}

window.OrderAttributes = new OrderAttributes();
